import { render, staticRenderFns } from "./GuideTypeSelectorModal.vue?vue&type=template&id=55d56501&scoped=true"
import script from "./GuideTypeSelectorModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./GuideTypeSelectorModal.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./GuideTypeSelectorModal.vue?vue&type=style&index=0&id=55d56501&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55d56501",
  null
  
)

export default component.exports